"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkTokenValidity = checkTokenValidity;
exports.del = del;
exports.get = get;
exports.post = post;
exports.put = put;
exports.request = request;
exports.url = url;
var _axios = _interopRequireDefault(require("axios"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _utils = require("../utils/utils");
var _AsyncStorageUtils = require("../utils/AsyncStorageUtils");
var _cookieHelper = require("../utils/cookieHelper");
var _login = require("../../astercore/auth/login/api/login");
var _ApiConst = require("../utils/ApiConst");
/* eslint no-useless-catch: "error" */
/* eslint-disable no-undef */

// import { AsyncStorageKey, getValueFromAsyncStorage, setTokensDataAsync } from '../utils/AsyncStorageUtils';

// There is lots of Data in some API so we need to add more timeout here
const TIMEOUT = 60000;
async function get({
  path,
  ...props
}) {
  // // console.log('===get start', Date.now());
  return bodyOf(request({
    method: 'get',
    path,
    body: null,
    ...props
  }));
}
async function post({
  path,
  body,
  ...props
}) {
  return bodyOf(request({
    method: 'post',
    path,
    body,
    ...props
  }));
}
async function put({
  path,
  body,
  ...props
}) {
  return bodyOf(request({
    method: 'put',
    path,
    body,
    ...props
  }));
}
async function del({
  path,
  body,
  ...props
}) {
  return bodyOf(request({
    method: 'delete',
    path,
    body,
    ...props
  }));
}
async function request({
  method,
  path,
  body,
  ...props
}) {
  // eslint-disable-next-line no-useless-catch
  // // console.log('===request start', Date.now());
  try {
    const response = await sendRequest({
      method,
      path,
      body,
      ...props
    });
    // // console.log('===sendRequest end', Date.now());
    // // console.log('===request end', Date.now());
    return handleResponse(path, response);
  } catch (error) {
    // // console.log('===request start', Date.now());
    const err = error;
    throw err;
  }
}
function url(path) {
  return path;
}

/**
 * Constructs and fires a HTTP request
 */
async function sendRequest({
  method,
  path,
  body,
  ...props
}) {
  // // console.log('===sendRequest start', Date.now());
  try {
    // // console.log('===endpoint start', Date.now());
    const endpoint = url(path);
    if ((0, _utils.isMobile)() && (path.includes(_ApiConst.PRODUCTS_BY_SEARCH) || path.includes(_ApiConst.PRODUCTS_BY_CATEGORY) || path.includes(_ApiConst.PRODUCTS_BY_BRAND))) {
      return timeout((0, _axios.default)(endpoint), TIMEOUT);
    }
    const headers = await getRequestHeaders(props);
    // // console.log('===options start', Date.now());
    const options = body ? {
      method,
      headers,
      data: JSON.stringify(body),
      body: JSON.stringify(body)
    } : {
      method,
      headers
    };
    // // console.log('===options end', Date.now());

    if (path.includes(_ApiConst.EPHARMACY_INITIATE_PAYMENT) || path.includes(_ApiConst.EPHARMACY_PAYMENT_CONFIRMATION)) {
      return timeout((0, _axios.default)(endpoint, options), TIMEOUT * 2);
    } else {
      return timeout((0, _axios.default)(endpoint, options), TIMEOUT);
    }
  } catch (e) {
    const error = e;
    throw new Error(error);
  }
}

/**
 * Receives and reads a HTTP response
 */
async function handleResponse(_path, response) {
  // eslint-disable-next-line no-useless-catch
  // // console.log('===handleResponse start', Date.now());
  try {
    const responseBody = response;
    const responseBodyJson = {};
    responseBodyJson.status = response.status;
    // eslint-disable-next-line no-useless-catch
    try {
      responseBodyJson.data = responseBody;
    } catch (e) {
      const error = e;
      throw error;
    }
    // // console.log('===handleResponse end', Date.now());
    return {
      status: response.status,
      headers: response.headers,
      body: responseBodyJson || null
    };
  } catch (e) {
    // // console.log('===handleResponse end', Date.now());
    const error = e;
    throw error;
  }
}
function checkTokenValidity(accessToken) {
  const decodedAccessTokenData = (0, _jwtDecode.default)(accessToken);
  const tokenExpiryTimeStamp = decodedAccessTokenData.exp;
  const currentTimeStamp = Math.floor(new Date() / 1000);
  return tokenExpiryTimeStamp > currentTimeStamp;
}
async function getRequestHeaders(props) {
  // get your data from Async storage in case of Mobile and from cookie in case of web.
  // // console.log('===getRequestHeaders start', Date.now());
  let header = {
    Accept: 'application/json'
  };
  const deviceId = (0, _utils.isMobile)() ? await (0, _AsyncStorageUtils.getValueFromAsyncStorage)(_AsyncStorageUtils.AsyncStorageKey.deviceId) : (0, _cookieHelper.getDataFromCookie)('deviceId');
  let strPlatform = (0, _utils.isMobile)() ? 'mobile' : 'web';
  const traceId = (0, _utils.generateTraceId)();
  if ((0, _utils.isMobile)()) {
    const platformSaved = (await (0, _AsyncStorageUtils.getValueFromAsyncStorage)(_AsyncStorageUtils.AsyncStorageKey.platform)) || 'mobile';
    strPlatform = platformSaved;
  }
  if (props.header === 2) {
    header = {
      ...header,
      ...props.appendHeader,
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'SAMEORIGIN',
      'X-Content-Type-Options': 'nosniff',
      'Content-Security-Policy': 'script-src "self"',
      'Permissions-Policy': 'payment=()"',
      'Referrer-Policy': 'strict-origin',
      'X-XSS-Protection': '1; mode=block',
      'Content-Type': 'application/json; charset=UTF-8',
      'x-patient-apiversion': '2.2.5'
    };
    if (_ApiConst.USER_AGENT) {
      header = {
        ...header,
        'X-User-Agent': (0, _utils.isMobile)() ? 'aster-mobile/2.1' : 'aster-web/2.1'
      };
    }
  } else {
    let token;
    token = (0, _utils.isMobile)() ? await (0, _AsyncStorageUtils.getValueFromAsyncStorage)(_AsyncStorageUtils.AsyncStorageKey.accessToken) : (0, _cookieHelper.getDataFromCookieAToB)('kcToken');
    if (token) {
      const isTokenValid = checkTokenValidity(token);
      if (isTokenValid === false && (0, _utils.isMobile)()) {
        try {
          const refreshToken = await (0, _AsyncStorageUtils.getValueFromAsyncStorage)(_AsyncStorageUtils.AsyncStorageKey.refreshToken);
          const newAccesstoken = await (0, _login.callAccessTokenApi)({
            isRefreshTokenGrant: true,
            refreshToken: refreshToken
          });
          // Save token detail here...
          token = newAccesstoken.access_token;
          // setTokensDataAsync(newAccesstoken);
          header = {
            ...header,
            Authorization: token ? `Bearer ${token}` : null,
            deviceId
          };
        } catch (error) {
          const tokenExpire = 'Access Token Expire';
          throw tokenExpire;
        }
      } else {
        header = {
          ...header,
          Authorization: token ? `Bearer ${token}` : null,
          deviceId
        };
      }
    } else {
      token = (0, _utils.isMobile)() ? await (0, _AsyncStorageUtils.getValueFromAsyncStorage)(_AsyncStorageUtils.AsyncStorageKey.guestToken) : (0, _cookieHelper.getDataFromCookie)('Guest_Token');
      header = {
        ...header,
        Authorization: token ? `guest-token ${token}` : null,
        deviceId
      };
    }
    header = {
      ...header,
      ...props.appendHeader,
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'SAMEORIGIN',
      'X-Content-Type-Options': 'nosniff',
      'Content-Security-Policy': 'script-src "self"',
      'Permissions-Policy': 'payment=()"',
      'Referrer-Policy': 'strict-origin',
      'X-XSS-Protection': '1; mode=block',
      'Content-Type': 'application/json; charset=UTF-8',
      'x-patient-apiversion': '2.2.5'
    };
    if (_ApiConst.USER_AGENT) {
      header = {
        ...header,
        'X-User-Agent': (0, _utils.isMobile)() ? 'aster-mobile/2.1' : 'aster-web/2.1'
      };
    }
  }
  header = {
    ...header,
    platform: strPlatform,
    traceId: traceId
  };
  // // console.log('===getRequestHeaders end', Date.now());
  return header;
}

/**
 * Rejects a promise after `ms` number of milliseconds, it is still pending
 */
function timeout(promise, ms) {
  // // console.log('===timeout start', Date.now());
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('timeout')), ms);
    promise.then(response => {
      clearTimeout(timer);
      resolve(response);
      // // console.log('===timeout end', Date.now());
    }).catch(reject);
  });
}
async function bodyOf(requestPromise) {
  // eslint-disable-next-line no-useless-catch
  // // console.log('===bodyOf start', Date.now());
  try {
    const response = await requestPromise;
    // // console.log('===bodyOf end', Date.now());
    return response.body;
  } catch (e) {
    // // console.log('===bodyOf end', Date.now());
    const error = e;
    throw error;
  }
}